import { AuthStore } from "./state";
import { createOAuthConfig } from "./config";
import { createFetchers } from "./fetchers";
import { createLocalStorage } from "./storage";
import { createTransactionStore } from "./transaction";

export const authStore = new AuthStore({
  config: createOAuthConfig(window.location.origin),
  fetchers: createFetchers(),
  storage: createLocalStorage(),
  transaction: createTransactionStore(),
});

export { AuthStore } from "./state";
export { AuthRequestError } from "./fetchers";
export type * from "./types";
